<header class="main-header">
  <div class="header-left">
    <div class="logo-container py-2 d-flex align-items-center">
      <img class="logo" src="/images/logo_tim_enterprise.svg" alt="Logo Tim Enterprise" />
    </div>
  </div>

  <div class="header-right">
    <!-- Sezione Notifiche e Monitoraggio Code Upload / Ingestion -->
    <div class="notifications-wrapper">
      <button 
        type="button" 
        class="btn-notification-trigger" 
        [class.has-active]="taskService.hasActiveTasks()"
        (click)="toggleNotifications()"
        title="Attività ed elaborazioni in corso">
        
        <span class="material-symbols-outlined notification-icon" [class.spinning]="taskService.hasActiveTasks()">
          {{ taskService.hasActiveTasks() ? 'sync' : 'notifications' }}
        </span>

        @if (taskService.activeCount() > 0) {
          <span class="notification-badge-count">{{ taskService.activeCount() }}</span>
        }
      </button>

      @if (isNotificationsOpen()) {
        <button type="button" 
                class="backdrop" 
                (click)="isNotificationsOpen.set(false)"
                aria-label="Chiudi notifiche"></button>
        <div class="notifications-panel shadow-lg">
          <div class="panel-header">
            <div class="d-flex align-items-center gap-2">
              <span class="material-symbols-outlined panel-header-icon">browse_activity</span>
              <span class="panel-title">Attività e Notifiche</span>
              @if (taskService.activeCount() > 0) {
                <span class="badge badge-active-pill">{{ taskService.activeCount() }} in corso</span>
              }
            </div>

            @if (hasCompletedOrErrorTasks()) {
              <button class="btn-clean-completed" (click)="clearCompleted()" title="Pulisci completati">
                Pulisci
              </button>
            }
          </div>

          <div class="panel-body">
            @if (taskService.tasks().length === 0) {
              <div class="empty-notifications">
                <span class="material-symbols-outlined empty-icon">task_alt</span>
                <span class="empty-title">Nessuna attività in corso</span>
                <span class="empty-subtitle">Le attività di upload e ingestion compariranno qui</span>
              </div>
            } @else {
              <div class="task-items-list">
                @for (task of taskService.tasks(); track task.id) {
                  <div class="task-card" [ngClass]="'status-' + task.status">
                    <div class="task-card-header">
                      <div class="task-label-group">
                        <div class="d-flex align-items-center gap-2">
                          <span class="task-label"
                                [ngbTooltip]="task.label"
                                tooltipClass="task-name-tooltip"
                                container="body"
                                placement="top">{{ task.label }}</span>
                          @if (task.indexName) {
                            <span class="task-index-badge">{{ task.indexName }}</span>
                          }
                        </div>
                        <span class="task-type-text">{{ task.type === 'DOCUMENT' ? 'Documento' : 'Sito Web' }}</span>
                      </div>

                      <div class="task-status-indicator" [ngClass]="'indicator-' + task.status">
                        @if (task.status === 'active') {
                          <span class="material-symbols-outlined spin-icon-status">progress_activity</span>
                          <span>{{ task.step || 'In elaborazione' }}</span>
                        } @else if (task.status === 'waiting') {
                          <span class="material-symbols-outlined">hourglass_empty</span>
                          <span>In attesa</span>
                        } @else if (task.status === 'completed') {
                          <span class="material-symbols-outlined">check_circle</span>
                          <span>Completato</span>
                        } @else if (task.status === 'error') {
                          <span class="material-symbols-outlined">error</span>
                          <span>Errore</span>
                        } @else if (task.status === 'cancelling') {
                          <span class="material-symbols-outlined spin-icon-status">progress_activity</span>
                          <span>Annullamento...</span>
                        } @else if (task.status === 'cancelled') {
                          <span class="material-symbols-outlined">block</span>
                          <span>Annullato</span>
                        }

                        @if (task.status === 'waiting' || task.status === 'active') {
                          <button class="btn-dismiss-task" (click)="cancelTask(task, $event)"
                                  [title]="task.status === 'active' ? 'Interrompi elaborazione' : 'Rimuovi dalla coda'">
                            <span class="material-symbols-outlined">{{ task.status === 'active' ? 'stop_circle' : 'delete' }}</span>
                          </button>
                        }

                        @if (task.status === 'completed' || task.status === 'error' || task.status === 'cancelled') {
                          <button class="btn-dismiss-task" (click)="removeTask(task.id, $event)" title="Chiudi notifica">
                            <span class="material-symbols-outlined">close</span>
                          </button>
                        }
                      </div>
                    </div>

                    @if (task.status === 'active' || task.status === 'waiting' || task.status === 'cancelling') {
                      <div class="task-progress-block">
                        <div class="d-flex justify-content-between align-items-center mb-1">
                          <span class="progress-step-msg text-truncate">
                            {{ task.progressMessage || (task.status === 'waiting' ? 'In coda per l\'elaborazione...' : 'Elaborazione...') }}
                          </span>
                          <span class="progress-percent-val">{{ task.progress }}%</span>
                        </div>
                        <div class="task-progress-track">
                          <div class="task-progress-bar" [style.width.%]="task.progress"></div>
                        </div>
                      </div>
                    } @else if (task.status === 'error' && task.error) {
                      <div class="task-error-block">
                        <span class="material-symbols-outlined">warning</span>
                        <span class="error-msg-text">{{ task.error }}</span>
                      </div>
                    } @else if (task.status === 'completed') {
                      <div class="task-completed-block">
                        <span>{{ task.progressMessage || 'Elaborazione terminata con successo' }}</span>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>

    <div class="user-profile d-flex align-items-center gap-3">
      <div class="user-details text-end">
        <span class="user-name fw-bold d-block">{{ user()?.firstName }} {{ user()?.lastName }}</span>
        <span class="user-role text-muted small">{{ user()?.email }}</span>
      </div>

      <div class="avatar-wrapper">
        <div class="avatar-initials bg-primary text-white rounded-circle d-flex align-items-center justify-content-center">
          {{ getInitials(user()?.firstName, user()?.lastName) }}
        </div>
      </div>

      <button class="btn btn-outline-danger btn-sm ms-2 logout-btn" (click)="logout()" title="Esci">
        <span class="material-symbols-outlined align-middle">logout</span>
      </button>
    </div>
  </div>
</header>
